import { useCallback } from "react"

export function useBreadcrumbs(contentLoader, navigateTo) {
  const { breadcrumbItems, expandedCategories, setExpandedCategories } =
    contentLoader

  const enhancedBreadcrumbs = useCallback(() => {
    return breadcrumbItems.map((item) => {
      if (!item.link) return item

      if (item.label === "Help Center") {
        return { ...item, onClick: () => navigateTo(null) }
      }

      if (item.categorySlug) {
        return {
          ...item,
          onClick: () => {
            const updatedExpandedCategories = { ...expandedCategories }

            if (item.parentPath) {
              item.parentPath.split("/").forEach((cat) => {
                updatedExpandedCategories[cat] = true
              })
            }

            updatedExpandedCategories[item.categorySlug] = true
            setExpandedCategories(updatedExpandedCategories)
            navigateTo("category", item.categorySlug, item.parentPath || "")
          },
        }
      }

      return item
    })
  }, [breadcrumbItems, expandedCategories, navigateTo, setExpandedCategories])

  return { breadcrumbs: enhancedBreadcrumbs() }
}

export default useBreadcrumbs
